import { useState, useEffect } from "react";
import Config from "../../Config";


import PlTitle from "../../elements/PlTitle";
import InputCombo from "../../helpers/InputCombo";



function KidsMove(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [row, setRowX] = useState({       
        ids: props.ids, 
        p_przedszkole_id: '_x_',
        p_grupa_id: '_x_',
    });

     
 

    const [placowki, setPlacowki] = useState( null );
    const [grupy, setGrupy] = useState(null);

 
 


      const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
   
 
        setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }



    const getGr = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,gr_pl', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       setGrupy(res.result.grupy);        
                       setPlacowki(res.result.placowki);
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

   





    const goMove = (e) => {

     
        if(row.p_przedszkole_id == '_x_')
        {
            props.mainView.showDialog( "Ups!", "Wybierz placówkę" , "ok" , null);  
            return;
        }

        if(row.p_grupa_id == '_x_')
            {
                props.mainView.showDialog( "Ups!", "Wybierz grupę" , "ok" , null);  
                return;
            }
     
        props.mainView.showDialog("Potwierdź", "Na pewno chesz przenieś dziecko do innej grupy?", "yesno", (p)=>{
          
                        ///--------
                        if(p == "yes") 
                            {
                                    saveData();
                            }
                        //--------
        } );
    }


    const saveData = () => {

        props.mainView.setProgress(-2);

      
 

        fetch( Config.url + '/rest_v1_kids,kids_move', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Wskazane dane zostały przeniesione", "ok" , null);         
                        
                        Config.removeFromBuffer( Config.cache_kids_search, props.userData );
                        
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }


    if(placowki == null)
    {
        setPlacowki([]);
        setGrupy([]);
        getGr();        
        return <span>...</span>
    }


    console.log(grupy);
    var grupyPl = new Array();

    var p = {
        v: "_x_",
        title: '- - - ',
    }

    grupyPl.push(p);

    for(var k=0; k<grupy.length; k++)
    {
        if(row.p_przedszkole_id != '_x_' && row.p_przedszkole_id == grupy[k].p_przedszkole_id)
        {
            var p = {
                v: grupy[k].v,
                title: grupy[k].title,
            }

            grupyPl.push(p);
        }
    }


    return (
        
        <div className="view_content">

                <h1><PlTitle userData={props.userData} /> </h1>

      

                <div className="tip">Uwaga 1: w przypadku przenoszenia dziecka do innej placówki dane dzieci i rodziców są powielane. </div>

                <div className="form_tab_title">Wybrano dzieci: ({props.ids.length}) </div>               

                <div>
                    {
                        props.ids.map(  (item, ix) => {
                            return <strong>
                                {item.title} &nbsp;
                            </strong>
                        } )
                    }
                </div>

                <form className="eForm bg_center">


                    <div className="form_tab">

                                    <div className="form_control">
                                                <div className="fieldName">Placówka</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={placowki} value={ row.p_przedszkole_id } err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_przedszkole_id" placeholder={":"} className='  ' req='0'   />
                                    </div>
 
                                 
                                    <div className="form_split"></div>

                                    <div className="form_control">
                                                <div className="fieldName">Grupa</div>
                                                <InputCombo mainView={props.mainView}   userData={props.userData} items={grupyPl} value={ row.p_grupa_id } err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={":"} className='  ' req='0'   />
                                    </div>


                                    <div className="form_split"></div>


                                    <div className="form_btn">
                                            <div className="btn" onClick={goMove}>zapisz zmiany</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>


                    </div>


                </form>

        </div>
    )
}


export default KidsMove;